import {useRouter} from 'next/router';
import {type FC, useEffect, useMemo, useState} from 'react';
import {
  GTAG_LOCATION,
  type GtagLocation,
} from '../../../../../config/constants/gtag';
import {useAuth} from '../../../../../core/usecases/auth/AuthContext';
import {cn} from '../../../../../lib/classname';
import {SpHeaderBanner} from '../../../../../shared/components/Banner/SpHeaderBanner';
import type {Breadcrumb} from '../../../../../shared/components/BreadcrumbsComponent';
import {useIsAppWebView} from '../../../../../shared/hooks/useIsAppWebView';
import {Breadcrumbs} from './Breadcrumbs';
import {Control} from './Control';
import {Title} from './Title';
import {type ListType, getActiveListTypeFromUrlPath} from './list-type';

const LIST_TYPE_LOCATION: Record<ListType, GtagLocation> = {
  recommended: GTAG_LOCATION.COLUMN_CATEGORIES,
  category: GTAG_LOCATION.SUB_CATEGORY_COLUMN_LIST,
  tag: GTAG_LOCATION.TAG_COLUMN_LIST,
  company: GTAG_LOCATION.COMPANY_COLUMN_LIST,
  sponsored: GTAG_LOCATION.SPONSORED_COLUMN_LIST,
  ranking: GTAG_LOCATION.RANKING_COLUMN_LIST,
  latest: GTAG_LOCATION.LATEST_COLUMN_LIST,
};

type Props = {
  className?: string;
  breadcrumbs: Breadcrumb[];
  title: string;
  description?: string;
};
export const Header: FC<Props> = ({
  className,
  breadcrumbs,
  title,
  description,
}) => {
  const isWebView = useIsAppWebView();
  const {status} = useAuth();
  const router = useRouter();
  const [listType, setListType] = useState<ListType>(
    getActiveListTypeFromUrlPath(router.asPath),
  );
  useEffect(() => {
    setListType(getActiveListTypeFromUrlPath(router.asPath));
  }, [router.asPath]);

  const showHeaderBanner = useMemo(() => {
    return status === 'authenticated';
  }, [status]);

  return (
    <div
      className={cn(
        'w-full max-w-[1200px] mx-auto overflow-x-hidden',
        'flex flex-col pc:gap-16 pc:py-8',
        className,
      )}
    >
      {!isWebView && (
        <Breadcrumbs className="mx-16 my-8 pc:m-0" breadcrumbs={breadcrumbs} />
      )}
      {showHeaderBanner && (
        <SpHeaderBanner
          location={LIST_TYPE_LOCATION[listType]}
          className="w-full inline-flex justify-center pc:hidden"
        />
      )}
      <Title title={title} description={description} listType={listType} />
      <Control listType={listType} />
    </div>
  );
};
